import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Icon from './icons';

const LEGACY_PASSWORD = 'amorlia_secure_123';

export default function LoginScreen({ onLegacyLogin }) {
  const { signIn, signUp, signInWithGoogle, isConfigured } = useAuth();
  const [mode, setMode] = useState(isConfigured ? 'login' : 'legacy'); // login | signup | legacy
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pass, setPass] = useState(''); // legacy
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLegacySubmit = (e) => {
    e.preventDefault();
    if (pass === LEGACY_PASSWORD || pass === (process.env.REACT_APP_DASHBOARD_PASSWORD || '')) {
      onLegacyLogin();
    } else {
      setError('Invalid password');
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError('');
    try {
      if (mode === 'signup') await signUp(email, password);
      else await signIn(email, password);
    } catch (err) {
      setError(err.message || 'Authentication failed');
    }
    setLoading(false);
  };

  const handleGoogle = async () => {
    setLoading(true);
    setError('');
    try { await signInWithGoogle(); }
    catch (err) { setError(err.message || 'Google sign-in failed'); setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #0A0A0F 0%, #1a0f0a 50%, #0A0A0F 100%)' }}>
      <div style={{ width: '100%', maxWidth: '420px', padding: '2rem' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{ width: '64px', height: '64px', background: 'linear-gradient(135deg, #FF6B35, #FF8A5C)', borderRadius: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem', fontSize: '1.75rem', fontWeight: 700, color: '#fff', boxShadow: '0 4px 20px rgba(255,107,53,0.4)' }}>A</div>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: '0.5rem', color: '#F8FAFC' }}>AMORLIA JEWELS</h1>
          <p style={{ color: '#94a3b8', fontSize: '0.9rem' }}>Product Management Dashboard</p>
        </div>

        {/* Mode tabs */}
        {isConfigured && (
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
            {['login', 'signup', 'legacy'].map(m => (
              <button key={m} onClick={() => { setMode(m); setError(''); }} style={{ flex: 1, padding: '0.5rem', background: mode === m ? 'rgba(255,107,53,0.15)' : 'transparent', border: `1px solid ${mode === m ? '#FF6B35' : 'rgba(255,255,255,0.08)'}`, borderRadius: '0.5rem', color: mode === m ? '#FF6B35' : '#94A3B8', fontSize: '0.8rem', fontWeight: mode === m ? 600 : 400, cursor: 'pointer', textTransform: 'capitalize' }}>
                {m === 'legacy' ? 'Password' : m}
              </button>
            ))}
          </div>
        )}

        {/* Legacy password form */}
        {mode === 'legacy' && (
          <form onSubmit={handleLegacySubmit}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.375rem', display: 'block' }}>Password</label>
              <input type="password" value={pass} onChange={e => setPass(e.target.value)} placeholder="Enter dashboard password" style={{ width: '100%', padding: '0.625rem 0.875rem', background: '#0f172a', border: '1px solid rgba(255,255,255,0.08)', color: '#f8fafc', borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none' }} autoFocus />
            </div>
            {error && <p style={{ color: '#ef4444', fontSize: '0.8rem', marginBottom: '0.75rem' }}>{error}</p>}
            <button type="submit" disabled={!pass} style={{ padding: '0.75rem', background: '#FF6B35', color: '#fff', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', width: '100%', opacity: !pass ? 0.6 : 1 }}>Sign In</button>
          </form>
        )}

        {/* Email/password form */}
        {(mode === 'login' || mode === 'signup') && (
          <form onSubmit={handleEmailSubmit}>
            {/* Google button */}
            <button type="button" onClick={handleGoogle} style={{ width: '100%', padding: '0.75rem', background: '#fff', color: '#333', border: '1px solid #ddd', borderRadius: '0.5rem', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
              <svg width="18" height="18" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
              Continue with Google
            </button>

            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.08)' }} />
              <span style={{ color: '#64748B', fontSize: '0.75rem' }}>or</span>
              <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.08)' }} />
            </div>

            <div style={{ marginBottom: '0.75rem' }}>
              <label style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.375rem', display: 'block' }}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" style={{ width: '100%', padding: '0.625rem 0.875rem', background: '#0f172a', border: '1px solid rgba(255,255,255,0.08)', color: '#f8fafc', borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none' }} required />
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ fontSize: '0.75rem', color: '#94a3b8', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.375rem', display: 'block' }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min 6 characters" style={{ width: '100%', padding: '0.625rem 0.875rem', background: '#0f172a', border: '1px solid rgba(255,255,255,0.08)', color: '#f8fafc', borderRadius: '0.5rem', fontSize: '0.875rem', outline: 'none' }} required />
            </div>
            {error && <p style={{ color: '#ef4444', fontSize: '0.8rem', marginBottom: '0.75rem' }}>{error}</p>}
            <button type="submit" disabled={loading || !email || !password} style={{ padding: '0.75rem', background: '#FF6B35', color: '#fff', border: 'none', borderRadius: '0.5rem', cursor: 'pointer', fontWeight: 600, fontSize: '0.875rem', width: '100%', opacity: loading ? 0.6 : 1 }}>
              {loading ? 'Please wait...' : mode === 'signup' ? 'Create Account' : 'Sign In'}
            </button>
          </form>
        )}

        {/* Guest option */}
        {isConfigured && (
          <button onClick={onLegacyLogin} style={{ marginTop: '1rem', width: '100%', padding: '0.75rem', background: 'transparent', color: '#64748B', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '0.8rem' }}>
            Continue as Guest (localStorage only)
          </button>
        )}
      </div>
    </div>
  );
}
